module.exports = __webpack_public_path__ + "media/images/athletes/3579-33829303ebad9f2a927737ff9ed548d3.png";